<template>
  <!--Footer Alert-->
  <transition name="fade">
    <div v-if="value" class="alert-footer w-full absolute bottom-0">
      <input type="checkbox" class="hidden" id="footeralert" />

      <div
        class="flex items-center justify-between w-full p-2 bg-green-400 shadow text-white"
      >
        {{ text }}

        <label
          @click="toggleFooter"
          class="close cursor-pointer"
          title="close"
          for="footeralert"
        >
          <svg
            class="fill-current text-white"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <path
              d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
            />
          </svg>
        </label>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  // props
  props: {
    // if the notification is open
    value: {
      type: Boolean,
      default: false
    },

    text: {
      type: String,
      default: ""
    }
  },

  // methods
  methods: {
    toggleFooter() {
      this.$emit("input", !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
